import React from "react";
import Chart from "react-apexcharts";
import { Loading } from "../../../componentes/loading/loading";

const DashboardBar = ({ orcadoObj = {}, realizadoObj = {}, realizadoObjAnterior = {}, loading = false, ano, onBarClick }) => {
  const labels = Array.from(
    new Set([...Object.keys(orcadoObj), ...Object.keys(realizadoObj), ...Object.keys(realizadoObjAnterior)])
  );

  const dataOrcado = labels.map((c) => orcadoObj[c] || 0);
  const dataRealizado = labels.map((c) => realizadoObj[c] || 0);
  const dataRealizadoAnterior = labels.map((c) => realizadoObjAnterior[c] || 0);

  const todosZerados = [...dataOrcado, ...dataRealizado].every((valor) => valor === 0);

  const temAnoAnterior = ano?.some(a => a < 2026);
  const somente2026 = ano?.length === 1 && ano.includes(2026);

  let series = [
    { name: "Orçado", data: dataOrcado },
    { name: "Realizado", data: dataRealizado }
  ];

  if (somente2026 && !temAnoAnterior) {
    series.push({
      name: "Realizado em 2025",
      data: dataRealizadoAnterior
    });
  }

  const options = {
    chart: {
      type: "bar",
      toolbar: { show: true },
      animations: {
        enabled: false
      },
      events: onBarClick
        ? {
          dataPointSelection: (event, chartContext, config) => {
            const label = labels[config.dataPointIndex];
            if (!label) return;

            const codigo = label.includes(" - ")
              ? label.split(" - ")[0].trim()
              : label;

            onBarClick(codigo);
          },
        }
        : undefined,
    },
    plotOptions: {
      bar: {
        borderRadius: 2,
        horizontal: false,
        columnWidth: "50%",
      },
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      categories: labels,
    },
    yaxis: {
      labels: {
        formatter: (value) =>
          new Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
            maximumFractionDigits: 0,
          }).format(value),
      },
    },
    tooltip: {
      y: {
        formatter: (value) =>
          new Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
          }).format(value),
      },
    },
    colors: ["#271de0ff", "#e03737ff", "#ff9900"],
    legend: {
      position: "top",
      horizontalAlign: "left",
      fontSize: "12px",
    },
  };

  return (
    <div className={`min-h-[355.8px] ${onBarClick ? "cursor-pointer" : ""}`}>
      {loading ? (
        <Loading />
      ) : todosZerados ? (
        <p className="text-muted-foreground text-center">
          Não há dados disponíveis para exibir o gráfico.
        </p>
      ) : (
        < Chart options={options} series={series} type="bar" height={340} />
      )}
    </div>
  );
};

export default DashboardBar;